export const checkFunciona = [
  { label: 'Freio de pé', value: 'freio_pe' },
  { label: 'Freio de estacionamento', value: 'freio_estacionamento' },
  { label: 'Motor de partida', value: 'motor_partida' },
  { label: 'Limpador de parabrisa', value: 'limpador_parabrisa' },
  { label: 'Lavador de Parabrisa', value: 'lavador_parabrisa' },
  { label: 'Buzina', value: 'buzina' },
  { label: 'Farois', value: 'farois' },
  { label: 'Pisca Alerta', value: 'pisca_alerta' },
  { label: 'Setas Dianteiras', value: 'setas_dianteiras' },
  { label: 'Setas Traseiras', value: 'setas_traseiras' },
  { label: 'Luz de freio', value: 'luz_freio' },
  { label: 'Luz de ré', value: 'luz_re' },
  { label: 'Luz da placa', value: 'luz_placa' },
  { label: 'Indicadores do painel', value: 'indicadores_painel' },
  { label: 'Cinto de segurança', value: 'cinto_seguranca' },
  { label: 'Fechamento das janelas', value: 'fechamento_janelas' },
  { label: 'Travas das portas', value: 'travas_portas' },
  { label: 'Alarme', value: 'alarme' },
];

export const checkPossui = [
  { label: 'Triângulo de advertência', value: 'triangulo_advertencia' },
  { label: 'Macaco', value: 'macaco' },
  { label: 'Chave de roda', value: 'chave_roda' },
];

export const checkCondicoes = [
  { label: 'Condição Pneu', value: 'condicao_pneu' },
  { label: 'Pneu Estepe', value: 'pneu_estepe' },
];

export const checkAvarias = [
  { label: 'Vidros', value: 'vidros' },
  { label: 'Portas', value: 'portas' },
  { label: 'Para-choque dianteiro', value: 'parachoque_diant' },
  { label: 'Para-choque traseiro', value: 'parachoque_tras' },
  { label: 'Lataria', value: 'lataria' },
  { label: 'Espelhos retrovisores', value: 'espelhos_retrovisor' },
  { label: 'Bancos', value: 'bancos' },
  { label: 'Teto', value: 'teto' },
  { label: 'Quebra Sol', value: 'quebra_sol' },
];

export const checkNivel = [
  { label: 'Nível de óleo', value: 'nivel_oleo' },
  { label: 'Nível de fluído de freio', value: 'fluido_freio' },
  { label: 'Nível de água', value: 'nivel_agua' },
];

export const checkEmDia = [
  { label: 'Habilitação', value: 'habilitacao' },
  { label: 'Manuteção Preventiva', value: 'manut_preven' },
  { label: 'Vazamentos', value: 'vazamentos' },
  { label: 'Calibracao Pneu', value: 'calibracao_pneu' },
];

export const checklistGroups = [
  { title: 'Não funcionam', items: checkFunciona },
  { title: 'Veículo não possui', items: checkPossui },
  { title: 'Condições ruins', items: checkCondicoes },
  { title: 'Com avarias', items: checkAvarias },
  { title: 'Não estão no nível', items: checkNivel },
  { title: 'Não estão em dia', items: checkEmDia },
];

export const photoLabels = [
  { campo: 'traseira', label: 'Foto traseira' },
  { campo: 'dianteira', label: 'Foto dianteira' },
  { campo: 'lateral_esquerda', label: 'Lateral esquerda' },
  { campo: 'lateral_direita', label: 'Lateral direita' },
  { campo: 'painel_interno', label: 'Painel interno' },
  { campo: 'bancos_frontais', label: 'Bancos frontais' },
  { campo: 'banco_traseiro', label: 'Banco traseiro' },
  { campo: 'porta_malas_aberto', label: 'Porta-malas aberto' },
  { campo: 'primeira_opcional', label: 'Foto opcional 1' },
  { campo: 'segunda_opcional', label: 'Foto opcional 2' },
];

export const checklistCampos = [
  'freio_pe',
  'freio_estacionamento',
  'motor_partida',
  'limpador_parabrisa',
  'lavador_parabrisa',
  'buzina',
  'farois',
  'pisca_alerta',
  'setas_dianteiras',
  'setas_traseiras',
  'luz_freio',
  'luz_re',
  'luz_placa',
  'indicadores_painel',
  'cinto_seguranca',
  'fechamento_janelas',
  'travas_portas',
  'alarme',
  'triangulo_advertencia',
  'macaco',
  'chave_roda',
  'condicao_pneu',
  'calibracao_pneu',
  'pneu_estepe',
  'vidros',
  'portas',
  'parachoque_diant',
  'parachoque_tras',
  'lataria',
  'espelhos_retrovisor',
  'bancos',
  'teto',
  'quebra_sol',
  'nivel_oleo',
  'fluido_freio',
  'nivel_agua',
  'habilitacao',
  'manut_preven',
  'vazamentos',
];
